import React from 'react';
import Header from './DataTableComponents/Header';

export default class BasicDataTable extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data,
			loading: false
		};
		// console.log(this.state);

		// this.loadData = this.loadData.bind(this);
	}

	// componentDidMount() {
	// 	if (!this.state.data || this.state.data.length === 0) {
	// 		this.loadData();
	// 	}
	// }

	// componentDidUpdate(prevProps) {
	// 	if (
	// 		prevProps.endpoint !== this.props.endpoint ||
	// 		prevProps.totalRecords !== this.props.totalRecords
	// 	) {
	// 		this.loadData();
	// 		// window.scrollTo({
	// 		// 	top: 0,
	// 		// 	left: 0,
	// 		// 	behavior: 'smooth'
	// 		// });
	// 	}
	// }

	render() {
		// console.log('DataTable - Props', this.props);
		// console.log('DataTable - State', this.state);

		return (
			<div className="m-2 p-2">
				<table className="w-full">
					<thead className="bg-gray-100 border-t-2 border-b-2 border-gray-300">
						<tr>
							{this.props.columns.map((column) => (
								<th
									key={column.displayName}
									className={'px-3 text-' + column.alignment}
								>
									<Header column={column} sortingEnabled={false} />
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{this.state.data.map((d) => {
							return this.props.rowRenderer(d);
						})}
					</tbody>
				</table>
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
			</div>
		);
	}

	/**
	 * Change Handlers
	*/

	/**
	 * Helper Functions 
	*/

	// loadData() {
	// 	this.setState({ loading: true });
	// 	$.ajax({
	// 		type: 'POST',
	// 		url: this.props.endpoint
	// 	}).done((payload) => {
	// 		const { data, meta } = payload;
	// 		// console.log('DataTable loadData done', payload, data, meta);
	// 		this.setState({ data: data, meta: meta, loading: false }, () => {
	// 			this.props.onChange({ target: { name: 'meta', value: meta } });
	// 		});
	// 	});
	// }
}
